module.exports = __webpack_public_path__ + "img/0S6A9711.d450662c.jpg";